import module from 'fan/proyecto/module.js'
import template from './template.html'

export class FanProyectoDocumentosInformacionfiscalPeriodosArchivosReciboisrAgregarComponent {
  idProyecto
  reciboisr
  periodo
  ejercicio
  onChange
  agregando = false
  accept = 'application/pdf'
  file = null

  constructor (FanProyectoDocumentosService, $fileSystem) {
    this.FanProyectoDocumentosService = FanProyectoDocumentosService
    this.$fileSystem = $fileSystem
  }

  agregar (files) {
    if (this.agregando) return

    this.agregando = true
    this.file = files[0]

    this.FanProyectoDocumentosService.postReciboisr(this.idProyecto, this.ejercicio, this.periodo, this.file)
      .then(({data}) => {
        this.reciboisr = data
        this.onChange({$event: {data: this.reciboisr}})
      })
      .finally(() => (this.agregando = false))
  }

  seleccionar () {
    this.$fileSystem.select(false, this.accept)
      .then((files) => (this.agregar(files)))
  }
}

module.component('fanProyectoDocumentosInformacionfiscalPeriodosArchivosReciboisrAgregar', {
  controller: FanProyectoDocumentosInformacionfiscalPeriodosArchivosReciboisrAgregarComponent,
  template,
  bindings: {
    idProyecto: '<',
    reciboisr: '<',
    periodo: '<',
    ejercicio: '<',
    onChange: '&',
  },
})



// WEBPACK FOOTER //
// ./src/fan/proyecto/components/documentos/informacionfiscal/periodos/archivos/reciboisr/agregar/component.js